import { IconButton, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { Warning as WarningIcon, Replay as ReplayIcon } from 'mui/icons';

const LoadingErrorWidget = ({ onReload }) => {
  const { errors } = useSelector((state) => state.i18n);
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      flexWrap: 'nowrap',
      maxWidth: 400,
      gap: 2,
    }}>
      <WarningIcon style={{
        color: 'var(--qhs-st-critical-tx)',
        paddingRight: 10,
        width: 35,
      }} />
      <Typography style={{
        color: 'var(--qhs-text-1)',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        fontSize: '.8rem',
      }}>
        {errors.loadingError}
      </Typography>

      <IconButton
        aria-label='update'
        onClick={onReload}
        style={{ color: 'var(--qhs-text-2)' }}
      >
        <ReplayIcon />
      </IconButton>
    </div>
  );
};

export default LoadingErrorWidget;
